const ApiVersion = 'v1'

const VersionTwo = 'v2'

export class KeyingAppEnvironmentConfig {
  private readonly _masterKeyApiUrl: string
  private readonly _isAlohomora: boolean

  private constructor(masterKeyApiUrl: string, isAlohomora: boolean) {
    this._masterKeyApiUrl = masterKeyApiUrl
    this._isAlohomora = isAlohomora
  }
  public static createKeyingEnvironmentConfig(env: any): KeyingAppEnvironmentConfig {
    if (!env.masterKeyApiUrl) {
      throw new Error('masterKeyApiUrl cannot be empty')
    }

    return new KeyingAppEnvironmentConfig(env.masterKeyApiUrl, env.isAlohomora)
  }
  public getBaseUrl(): string {
    if (!this._isAlohomora) {
      return `${this._masterKeyApiUrl}/v1`
    }
    return `${this._masterKeyApiUrl}/v1`
  }
  public getUsersUrl(): string {
    return `${this.getBaseUrl()}/users`
  }

  get baseUrl(): string {
    return `${this._masterKeyApiUrl}/${ApiVersion}`
  }

  baseCylinderApiUrl(): string {
    return `${this._masterKeyApiUrl}/${VersionTwo}`
  }
}
